export const siteResourceFieldKeyName = 'accountName';
export const API_BLOCK_SITES_PERMISSION = 'API_BLOCK_SITES_EDIT';
export const ALLOW_INCLUDE_SITES_PERMISSION = 'ALLOW_PUBLISHER_WHITELIST';
